function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export class GraphQLCache {
  constructor() {
    _defineProperty(this, "_entityCacheMap", new Map());
  }
  getCache(entityName, entityId) {
    let mapKey = entityId ? `${entityName}-${entityId}` : entityName;
    let cache = this._entityCacheMap.get(mapKey);
    if (cache) {
      return cache;
    }
    cache = new GraphQLEntityCache();
    this._entityCacheMap.set(mapKey, cache);
    return cache;
  }
}
export class GraphQLEntityCache {
  constructor() {
    _defineProperty(this, "_queryCacheMap", new Map());
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  set(options, response) {
    let hash = hashOptions(options);
    this._queryCacheMap.set(hash, {
      response,
      timestamp: Math.round(+new Date() / 1000)
    });
  }
  get(options) {
    let hash = hashOptions(options);
    return this._queryCacheMap.get(hash);
  }
  clear() {
    this._queryCacheMap.clear();
  }
  remove(options) {
    let hash = hashOptions(options);
    this._queryCacheMap.delete(hash);
  }
}
export default GraphQLCache;

// Based on: https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
function hashOptions(options) {
  let str = JSON.stringify(options);
  let hash = 0;
  if (str.length === 0) return hash;
  for (let i = 0; i < str.length; i++) {
    let chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}